<script>
import { panel_state, about_panel_state } from "./util/stores.js"
import Nav from "./Nav.svelte"
import Modules_picker_panel from "./Modules_picker_panel.svelte"
import Modules_board from "./Modules_board.svelte"
import About from "./About.svelte"

let p_state = "expanded"
let about_state = true

function ActuatePanel(){
    if(p_state == 'expanded'){
        panel_state.set('contracted')

    }else{
        panel_state.set('expanded')
    }
}

panel_state.subscribe(value => {
    p_state = value;
});

about_panel_state.subscribe(value => {
    about_state = value;
});

</script>

<main class="bg">

    <div class="color_strip"></div>

    <Nav></Nav>

    {#if about_state}
        <About></About>
    {/if}

    
    <div class="left_panel">
        <Modules_picker_panel></Modules_picker_panel>
        <button type="button" on:click={ActuatePanel}>
            <div class="arrow {p_state}"></div>
        </button>
    </div>
    

    <div class="board {p_state == 'expanded' ? 'expanded_panel' : ''}">
        <Modules_board></Modules_board>
    </div>

</main>

<style lang="scss">

.bg{
    background: url("../pics/bg_1.png"), #FFFFFF;

    background-position: center center;
    background-repeat: repeat;
    background-size: 720px;
}


.color_strip{
    width: 100vw;
    height: $col_strip_h;
    background-color: $accent_purple;
}

.left_panel{
    height: calc(100% - #{$col_strip_h} - #{$nav_bar_h});
    position: absolute;
    z-index: 8;

    button{
        cursor:pointer;

        border: none;
        border-radius: 0px 16px 16px 0px;
        width: 32px;
        height: 32px;

        position: absolute;
        z-index: 7;
        top:0;
        left: 0;

        background: #FFFFFF;
        //box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);

        transition: $left_panel_trans_speed ease;

        .arrow{
            width: 100%;
            height: 100%;

            background-image: url('../pics/icons/arrow_icon.svg');
            background-size: 100% 100%;
            pointer-events: none;

            transition: $left_panel_trans_speed ease;
        }

        .expanded{
            transform: rotate(180deg);
            //left: $logo_width;
        }

        .contracted{
            transform: rotate(0deg);
            border-radius: 0px 16px 16px 0px;
            box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
            //background-color: $accent_purple_light;
            //left:0;
        }
    }
}

.board{
    height: calc(100% - #{$col_strip_h} - #{$nav_bar_h});
    width: 100%;
    transition: $left_panel_trans_speed;
}

.expanded_panel{
    width: calc(100% - #{$logo_width});
    margin-left: $logo_width;
}

</style>